export const defaultColor = [
  "#FD8A8A",
  "#F1F7B5",
  "#A8D1D1",
  "#9EA1D4",
  "#FFF2CC",
  "#FFD966",
  "#DFA67B",
  "#554994",
  "#F675A8",
  "#54BAB9",
  "#6D8B74",
  "#5F7161",
  "#D18CE0",
  "#1572A1",
  "#70AF85",
  "#5AA469",
  "#EB6383",
  "#EF4B4B",
  "#00DFA2",
];
